var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('popup-warp',{attrs:{"value":_vm.value},on:{"input":_vm.onInput}},[_c('div',{staticClass:"select-lang-top"},[_c('span',{on:{"click":function($event){return _vm.onInput(false)}}},[_vm._v("取消")]),_c('span',{on:{"click":_vm.onSelect}},[_vm._v("确定")])]),_c('select-column',{attrs:{"values":_vm.localeArr},on:{"select":_vm.isSelect}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }